import {
    Box,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Autocomplete,
} from '@mui/material';

// Gemeinsamer "Übung auswählen/hinzufügen"-Dialog mit Kategorie-/Zielmuskel-Filter.
// `options` wird vom Parent gebaut; `groupBy` (optional) aktiviert die Gruppierung
// (z. B. Standard-/Eigene Übungen in den Trainingsergebnissen).
function UebungAuswahlDialog({
    open,
    onClose,
    onConfirm,
    isEdit,
    filterKategorie,
    onFilterKategorie,
    filterZielmuskel,
    onFilterZielmuskel,
    kategorien,
    zielmuskeln,
    options,
    groupBy,
    selectedUebung,
    onSelectUebung,
}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            fullScreen={window.innerWidth < 600}
        >
            <DialogTitle>
                {isEdit ? 'Übung ändern' : 'Übung hinzufügen'}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Kategorie</InputLabel>
                            <Select
                                value={filterKategorie}
                                onChange={(e) => onFilterKategorie(e.target.value)}
                                label="Kategorie"
                            >
                                <MenuItem value="">Alle</MenuItem>
                                {kategorien.map(k => <MenuItem key={k} value={k}>{k}</MenuItem>)}
                            </Select>
                        </FormControl>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Zielmuskel</InputLabel>
                            <Select
                                value={filterZielmuskel}
                                onChange={(e) => onFilterZielmuskel(e.target.value)}
                                label="Zielmuskel"
                            >
                                <MenuItem value="">Alle</MenuItem>
                                {zielmuskeln.map(z => <MenuItem key={z} value={z}>{z}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Box>

                    <Autocomplete
                        options={options}
                        groupBy={groupBy}
                        getOptionLabel={(o) => `${o.name || o.uebung_name || o.uebungen_name} (${o.zielmuskel})`}
                        value={selectedUebung}
                        onChange={(e, newValue) => onSelectUebung(newValue)}
                        renderInput={(params) => <TextField {...params} label="Übung suchen" />}
                        renderOption={(props, option) => {
                            const { key, ...other } = props;
                            return (
                                <li key={key} {...other}>
                                    <Box>
                                        <Typography variant="body1">{option.name || option.uebung_name || option.uebungen_name}</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {option.zielmuskel} • {option.kategorie}
                                        </Typography>
                                    </Box>
                                </li>
                            );
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    disabled={!selectedUebung}
                >
                    {isEdit ? 'Ändern' : 'Hinzufügen'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default UebungAuswahlDialog;
